import React from 'react';

const UnlinkSvg = () => {
  return (
    <svg
      className="Icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <symbol xmlns="http://www.w3.org/2000/svg" id="83964" viewBox="0 0 16 16">
        <path d="M12.824 3.199a1.342 1.342 0 0 0-1.898-.033L8.996 5.03a1.342 1.342 0 1 0 1.864 1.931l1.93-1.865a1.342 1.342 0 0 0 .034-1.897zM9.994 2.2a2.684 2.684 0 1 1 3.73 3.862l-1.932 1.864a2.684 2.684 0 0 1-3.73-3.861L9.995 2.2zM6.56 9.462a1.342 1.342 0 0 0-1.897-.033l-1.931 1.864a1.342 1.342 0 0 0 1.865 1.931l1.93-1.864a1.342 1.342 0 0 0 .034-1.898zm-2.83-.999a2.684 2.684 0 0 1 3.73 3.862L5.529 14.19a2.684 2.684 0 0 1-3.73-3.862l1.932-1.865zM6.716.093l-.26 2.472-.89-.094L5.827 0l.89.093zM1.753.938l2.405 2.615-.658.605-2.405-2.615.658-.605zM.093 5.567l2.472.26-.094.89L0 6.456l.093-.89zm15.814 4.866-2.472-.26.093-.89 2.472.26-.093.89zM12.5 11.842l2.405 2.615-.658.605-2.405-2.615.658-.605zm-3.216 4.065.26-2.472.89.093-.26 2.472-.89-.093z" />
      </symbol>
      <use xlinkHref="#83964" />
    </svg>
  );
};

export default UnlinkSvg;
